import type { FaireProductEntity } from "../../entity_types/product";

export const p_r9wmvtvxr5: FaireProductEntity = {
  token: "p_r9wmvtvxr5",
  type: "product",
  name: "Solid Ribbed Plush Throw Blanket 50\"x70\"",
  brandToken: "b_br6ji29u",
  brandName: "Softies",
  imageUrl: "https://cdn.faire.com/fastly/3edb18505d0cf18dce3c37ca611adcc5bec9e3e1646138db3680822babc4df93.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/cb88bc44688ff0e7dd8714265fc736cdd52b37b7fdb1106adb0988b086d011fa.jpeg",
    "https://cdn.faire.com/fastly/ae5dce8eb1fe091bd0827b488ebca25d35624d9ce1d052db9bbacd00a1977502.jpeg",
    "https://cdn.faire.com/fastly/73e1e582cf6cd617c63f9bf5aaab518ecd9e1037878c4fc1337fd2475e47782c.jpeg",
    "https://cdn.faire.com/fastly/28a09ae9a579de34671b2dc0f58e45e8512897b3b02133dab77876b6efffb829.jpeg",
    "https://cdn.faire.com/fastly/40a74668dcb0edeb164f7264cb95f8ee7e106954564ed0d2dd7b2ac4340c34c6.jpeg",
    "https://cdn.faire.com/fastly/b4648d089cd9b929a9a4bb0a36f77a4e17afbdaa37a4846264d26642e2e2cbaa.jpeg",
    "https://cdn.faire.com/fastly/e121d4b9e00825546ececc73ff442677605690b6d515b31e646db033d9e900ba.jpeg",
    "https://cdn.faire.com/fastly/847c083bf6690b1e31b6445e34416392b7de8adb0132118d353b56f783fa614a.jpeg",
    "https://cdn.faire.com/fastly/a81e540204bf42ad4227c1af782a270fa8ff483a1f1f4a9ae3791ccc0b6a0d3f.jpeg",
    "https://cdn.faire.com/fastly/7926a0090cd854adb365c0b57c5a3d46b855fcf57e3b8b5c493871b0b2fbef6d.jpeg",
    "https://cdn.faire.com/fastly/d75772f8767fa10a616d11a66cc0cfaf47b9c6162a35f53ae1f5824cffa9d084.jpeg",
    "https://cdn.faire.com/fastly/868ca364d9e673c2a286349edc912babf708230d125b5385f09aa1ebef9ea46a.jpeg",
    "https://cdn.faire.com/fastly/6956822db1a795f065212e64b9caa8f84ce4a5bd2968b1016dbbf30ed319cc0f.jpeg"
  ],
  priceDollars: 60,
  description: "Cozy never felt so good! Softies’ Marshmallow Blanket is superbly soft, lightweight, and made with lush ribbed fabric that you’ll want to snuggle with all day. This oversized soft blanket is just what you need for relaxing on a chilly evening or cuddling on the couch on a rainy day. Not only will you love our Marshmallow Blanket, but you’ll also enjoy the wrapped bow-tie, making it the perfect ready-to-give gift for any occasion.",
  tags: [],
  msrpDollars: 129,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-02T03:47:04.618Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
